import { render } from "./ServiceJobsView.vue?vue&type=template&id=618dc9ee&ts=true"
import script from "./ServiceJobsView.vue?vue&type=script&lang=ts"
export * from "./ServiceJobsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__